var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{staticClass:"main-header",attrs:{"left-arrow":_vm.leftarrow,"title":_vm.title,"fixed":true},on:{"click-left":_vm.lroute}})}
var staticRenderFns = []

export { render, staticRenderFns }